import { UnlinkedTeachersList } from '@/components/admin/UnlinkedTeachersList'

export function TeacherLinkingPage() {
  return (
    <div className="p-6 max-w-6xl">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Benutzer-Verknüpfung</h1>
        <p className="text-sm text-gray-500">
          Lehrer ohne Benutzerkonto verknüpfen oder neue Benutzer erstellen
        </p>
      </div>
      <UnlinkedTeachersList />
    </div>
  )
}